import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "onlyPageIndicators", "pageIndicatorIcon", "show", "disableIndicatorsOnLimit", "directionIndicatorIcons"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useContext } from 'react';
import { Pagination as SemanticPagination } from 'semantic-ui-react';
import _get from 'lodash/get';
import { DirectionIndicatorIconsPropType } from './PaginationIndicators.types';
import { getPaginationIndicatorProps } from './PaginationIndicators.utils';
import { GoogleAnalytics } from '../../../../../../services/analytics';
import { classNames } from '../../../../../../utils/classname';
import { EVENT_ACTIONS } from '../../../../../analytics/components/Event/Event.constants';
import useSemanticUiProps from '../../../../hooks/use-semantic-ui-props';
import { PaginationContext } from '../../contexts/pagination';
import './PaginationIndicators.css';
var defaultProps = {
  className: '',
  onlyPageIndicators: false,
  pageIndicatorIcon: '',
  show: true,
  disableIndicatorsOnLimit: false,
  directionIndicatorIcons: {}
};
export default function PaginationIndicators(_ref) {
  var className = _ref.className,
    onlyPageIndicators = _ref.onlyPageIndicators,
    pageIndicatorIcon = _ref.pageIndicatorIcon,
    show = _ref.show,
    disableIndicatorsOnLimit = _ref.disableIndicatorsOnLimit,
    directionIndicatorIcons = _ref.directionIndicatorIcons,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getMenuProps = _useSemanticUiProps.getMenuProps;
  var _useContext = useContext(PaginationContext),
    pagination = _useContext.pagination,
    event = _useContext.event;
  var activePage = pagination.activePage,
    totalPages = pagination.totalPages,
    onPageChange = pagination.onPageChange;
  var paginationIndicatorProps = getPaginationIndicatorProps({
    onlyPageIndicators: onlyPageIndicators,
    pageIndicatorIcon: pageIndicatorIcon,
    activePage: activePage,
    totalPages: totalPages,
    disableIndicatorsOnLimit: disableIndicatorsOnLimit,
    directionIndicatorIcons: directionIndicatorIcons
  });
  if (totalPages <= 1 || !show) {
    return null;
  }
  var finalClassName = classNames(_defineProperty({
    'pagination-indicators': true
  }, className, className));
  function handlePageChange(e, data) {
    var category = _get(event, 'category');
    var action = EVENT_ACTIONS.PAGINATION_INDICATOR_EVENT_ACTION;
    onPageChange(e, data);
    GoogleAnalytics.event(category, action, {
      label: data.activePage
    });
  }
  return /*#__PURE__*/React.createElement(SemanticPagination, _extends({
    activePage: activePage,
    onPageChange: handlePageChange,
    totalPages: totalPages,
    className: finalClassName
  }, getMenuProps(_objectSpread({}, rest)), paginationIndicatorProps));
}
PaginationIndicators.defaultProps = defaultProps;